import React from 'react';
import PropTypes from 'prop-types';
import {
    Grid,
    Paper,
    Table,
    Button
} from 'material-ui';
import TableLanguagesHeader from './TableLanguagesHeader';
import TableSitesInputs from './TableSitesInputs';

class TableReviewsAllocation extends React.Component {

    componentDidMount() {
        this.props.mountConfigurationGrid();
    }

    render() {
        const {
            classes, 
            languages, 
            sites, 
            sitesLanguages, 
            handleSubmit, 
            changeSiteLanguage, 
            loading, 
            touched
        } = this.props;

        return (
            loading === false &&
            <form onSubmit={handleSubmit.bind(this)}>
                <Paper className={classes.root}>
                    <Table className={classes.table}>
                        <TableLanguagesHeader
                            languages={languages}
                            classes={this.props.classes}
                        />
                        <TableSitesInputs
                            sites={sites}
                            languages={languages}
                            sitesLanguages={sitesLanguages}
                            changeSiteLanguage={changeSiteLanguage}
                            classes={this.props.classes}
                        />
                    </Table>
                </Paper>
                <Grid container spacing={0} className={classes.root}>
                    <Grid item xs={12} className={classes.buttons}>
                        <Button type="submit" variant="raised" color="primary" className="floatRight" disabled={!touched || loading}>{loading ? 'Saving...' : 'Save'}</Button>
                    </Grid>
                </Grid>
            </form>
        );
    }
}

TableReviewsAllocation.propTypes = {
    classes: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    mountConfigurationGrid: PropTypes.func.isRequired,
    sites: PropTypes.array.isRequired,
    languages: PropTypes.array.isRequired,
    sitesLanguages: PropTypes.array.isRequired,
    changeSiteLanguage: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
};

export default TableReviewsAllocation;



// WEBPACK FOOTER //
// ./src/containers/configuration/forms/TableReviewsAllocation.jsx